import useAPI from '@/hooks/useAPI';
import NoteRepository from '@/repositories/NoteRepository';

const useMostRecentNote = (noteTypeSlug: string, objectId: string) => {
  const noteRepository = NoteRepository();

  return useAPI({
    queryKey: ['getMostRecentNote', noteTypeSlug, objectId],
    queryFn: async () => {
      return await noteRepository.getMostRecentNote({
        noteTypeSlug,
        objectId
      });
    }
  });
};

export default useMostRecentNote;
